module.exports = __webpack_public_path__ + "img/1f3232f.jpg";